import { useState } from "react";
import { format, parseISO, startOfDay } from "date-fns";
import { id as localeId } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePicker = ({ value, onChange, testId = "date-picker", placeholder = "Pilih tanggal" }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="flex h-11 w-full items-center gap-2 rounded-xl border border-input bg-white px-3 text-left text-sm focus:outline-none focus:ring-2 focus:ring-teal-600/40">
          <CalendarDays className="h-4 w-4 text-stone-400" />
          <span className={selected ? "text-stone-900" : "text-stone-400"}>
            {selected ? format(selected, "EEEE, d MMMM yyyy", { locale: localeId }) : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto rounded-xl p-0" align="start">
        <Calendar mode="single" locale={localeId} selected={selected} disabled={{ before: startOfDay(new Date()) }}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
